import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

function CalculatorHeroIntro({
    isAdmin,
    name,
    typeCoverageName,
    typeCoverageOptions,
    hideTypeCoverage = false,
    setClass,
    onNameChange,
    onTypeCoverageChange,
}) {
    return (
        <section className='HeroCard'>
            <div className='HeroCopy'>
                <h1 className='Title TitleCompact'>
                    {isAdmin ? 'Modificar cotización' : 'Cotizador'}
                </h1>
            </div>

            <div className='HeroInputs'>
                <div className={`HeroInput${hideTypeCoverage ? ' HeroInputFull' : ''}`}>
                    <label className='FieldLabel'>Tu nombre</label>
                    <InputText
                        value={name || ''}
                        className={setClass('name') ? 'TextInputError' : 'TextInput'}
                        placeholder='Introduzca su nombre'
                        autoComplete='name'
                        onChange={onNameChange}
                    />
                </div>

                {!hideTypeCoverage && (
                    <div className='HeroInput'>
                        <label className='FieldLabel'>Tipo de arrendamiento</label>
                        <Dropdown
                            value={typeCoverageName}
                            options={typeCoverageOptions || []}
                            optionLabel="type_coverage"
                            placeholder="Tipo de Arrendamiento"
                            className={setClass('type_coverage') ? 'DropdownError' : 'Dropdown'}
                            onChange={onTypeCoverageChange}
                        />
                    </div>
                )}
            </div>
        </section>
    );
}

export { CalculatorHeroIntro };
